import styles from './CourseCardEnrolled.module.css';
import CourseProgressRing from "../course-progress-ring/CourseProgressRing.tsx";
import Arrow from "../../generic/shapes/arrow/Arrow.tsx";
import { useNavigate } from 'react-router-dom';

function CourseCardEnrolled({ course }: { course: Course }) {
  const navigate = useNavigate();
  const percent = Math.round((course.completed_lessons / course.total_lessons) * 100);
  const isComplete = percent === 100;
  const isNew = percent === 0;

  const handleContinue = (course) => {
    navigate(`/courses/${course.id}/${course.last_chapter_id}/${course.last_lesson_id}`);
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardTop} style={{ '--course-color': course.color }}>
        <div className={styles.cardMeta}>
          <span className={styles.category}>{course.category}</span>
          <span className={`${styles.level} ${'level' + course.level}`}>{course.level}</span>
        </div>
        <CourseProgressRing percent={percent} color={course.color} />
      </div>

      <div className={styles.cardBody}>
        <h2 className={styles.cardTitle}>{course.title}</h2>
        <p className={styles.cardDesc}>{course.description}</p>
      </div>

      <div className={styles.cardFooter}>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{ width: `${percent}%`, background: course.color }}
          />
        </div>
        <div className={styles.progressMeta}>
          <span className={styles.lessonsCount}>
            {isComplete ? '✓ All' : `${course.completed_lessons}`} / {course.total_lessons} lessons
          </span>
          <span className={styles.duration}>{course.formatted_duration}</span>
        </div>

        {!isComplete && (
          <div className={styles.lastLesson}>
            <span className={styles.lastLessonLabel}>{isNew ? 'Start with' : 'Up next'}</span>
            <span className={styles.lastLessonTitle}>{course.last_lesson}</span>
          </div>
        )}

        <button
          className={styles.continueBtn}
          style={{ '--course-color': course.color }}
          onClick={() => handleContinue(course)}
        >
          {isComplete ? 'Review course' : isNew ? 'Start course' : 'Continue'}
          <Arrow />
        </button>
      </div>
    </div>
  );
}

export default CourseCardEnrolled;